<template>
	<n-modal v-model:show="modalVisible" :mask-closable="true" :trap-focus="false">
		<!-- no-vw：共享组件不在 /pc/ 路径，避免 postcss-px-to-viewport 按 750 稿放大到 PC -->
		<div class="seer-share-modal-no-vw" @click.stop>
			<button type="button" class="seer-share-modal-no-vw__close" @click="modalVisible = false">
				<img src="./close.png" alt="" />
			</button>
			<h3 class="seer-share-modal-no-vw__title">{{ title || t("square.detail.share") }}</h3>
			<div class="seer-share-modal-no-vw__list">
				<button
					v-for="(item, index) in shareList"
					:key="index"
					type="button"
					class="seer-share-modal-no-vw__item"
					@click="$emit('share', item)"
					:aria-label="
						t('square.detail.shareTo', {
							platform: item.text || t('square.detail.sharePlatform'),
						})
					"
				>
					<img :src="item.icon" :alt="item.text || t('square.detail.share')" />
					<span>{{ item.text }}</span>
				</button>
			</div>
			<button
				v-if="showCopyLink"
				type="button"
				class="seer-share-modal-no-vw__copy-link"
				@click.stop="$emit('copy')"
			>
				{{ copyLabel || t("square.detail.copyLink") }}
			</button>
		</div>
	</n-modal>
</template>

<script setup>
import { computed } from "vue";
import { NModal } from "naive-ui";
import { useI18n } from "~/composables/useI18n";

const props = defineProps({
	show: {
		type: Boolean,
		default: false,
	},
	shareList: {
		type: Array,
		default: () => [],
	},
	title: {
		type: String,
		default: "",
	},
	copyLabel: {
		type: String,
		default: "",
	},
	showCopyLink: {
		type: Boolean,
		default: true,
	},
});

const emit = defineEmits(["update:show", "share", "copy"]);
const { t } = useI18n();

const modalVisible = computed({
	get: () => props.show,
	set: value => emit("update:show", value),
});
</script>

<style lang="scss" scoped>
.seer-share-modal-no-vw {
	position: relative;
	width: min(420px, calc(100vw - 32px));
	padding: 32px 28px 28px;
	background: #ffffff;
	border-radius: 12px;
	box-sizing: border-box;

	&__close {
		position: absolute;
		top: 12px;
		right: 12px;
		width: 32px;
		height: 32px;
		padding: 0;
		border: none;
		background: transparent;
		color: #999999;
		font-size: 24px;
		line-height: 1;
		cursor: pointer;

		&:hover {
			color: #666666;
		}

		img {
			width: 20px;
			height: 20px;
		}
	}

	&__title {
		margin: 0 0 24px;
		color: #333333;
		font-size: 18px;
		font-weight: 700;
		line-height: 1.4;
		text-align: left;
	}

	&__list {
		display: grid;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		gap: 20px 16px;
	}

	&__item {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 8px;
		min-width: 0;
		padding: 0;
		border: none;
		background: transparent;
		cursor: pointer;
		transition: transform 0.15s ease;

		&:hover {
			transform: scale(1.05);
		}

		img {
			display: block;
			width: 48px;
			height: 48px;
			border-radius: 50%;
			object-fit: cover;
		}

		span {
			max-width: 100%;
			color: #333333;
			font-size: 14px;
			line-height: 1.3;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}

	&__copy-link {
		display: block;
		width: 100%;
		margin-top: 40px;
		padding: 10px 0;
		border: 1px solid #111111;
		border-radius: 8px;
		background: transparent;
		color: #333333;
		font-size: 18px;
		font-weight: 700;
		text-align: center;
		cursor: pointer;
	}
}

@media (max-width: 640px) {
	.seer-share-modal-no-vw {
		padding: 28px 20px 24px;

		&__list {
			gap: 18px 12px;
		}

		&__item img {
			width: 44px;
			height: 44px;
		}

		&__copy-link {
			margin-top: 32px;
			font-size: 16px;
		}
	}
}
</style>
